/**
 * Global AOGEN adapter API base for dev/prod switching.
 * Events catalog: Shopify App Proxy GET /apps/workshop-event/events-v (same-origin).
 * Capacity, validate, config, waitlist: direct /api/public/* on adapter (CORS).
 */
(function (w) {
  'use strict';

  var DEFAULT_BASE = 'https://adapter.aogen.com.au';
  var DEFAULT_PROXY_BASE = '/apps/workshop-event';
  var DEFAULT_EVENTS_PATH = '/events-v';

  function normalizeBase(base) {
    base = String(base || '').trim();
    if (!base) return DEFAULT_BASE;
    return base.replace(/\/$/, '');
  }

  function resolveBase() {
    return normalizeBase(w.__AOGEN_API_BASE__);
  }

  function apiUrl(path) {
    var p = String(path || '');
    if (p.charAt(0) !== '/') p = '/' + p;
    return resolveBase() + p;
  }

  function shopDomain() {
    var fromShopify = w.Shopify && w.Shopify.shop ? String(w.Shopify.shop).trim() : '';
    if (fromShopify) return fromShopify;
    return String(w.__AOGEN_SHOP_DOMAIN__ || '').trim();
  }

  function useDirectEventsCatalog() {
    return w.__AOGEN_USE_DIRECT_EVENTS__ === true;
  }

  function joinProxyPath(base, path) {
    var b = String(base || DEFAULT_PROXY_BASE).replace(/\/+$/, '');
    var p = String(path || DEFAULT_EVENTS_PATH);
    if (p.charAt(0) !== '/') p = '/' + p;
    var last = b.split('/').pop();
    var first = p.split('/').filter(Boolean)[0];
    if (last && first && last === first) b = b.slice(0, b.length - last.length - 1);
    return b + p;
  }

  function appendShopQuery(queryString) {
    var qs = String(queryString || '');
    var shop = shopDomain();
    if (!shop) return qs;
    if (/(^|&)shop=/.test(qs)) return qs;
    return qs ? qs + '&shop=' + encodeURIComponent(shop) : 'shop=' + encodeURIComponent(shop);
  }

  /**
   * Build workshop events catalog request.
   * Returns { url, useDirect, fetchInit } where fetchInit omits signal (caller merges).
   */
  function buildEventsRequest(queryString, proxyBase, eventsPath) {
    var qs = String(queryString || '');
    var proxy = joinProxyPath(proxyBase, eventsPath);
    if (useDirectEventsCatalog() && shopDomain()) {
      return {
        url: apiUrl('/api/events') + '?' + appendShopQuery(qs),
        useDirect: true,
        fetchInit: {
          method: 'GET',
          credentials: 'omit',
          mode: 'cors',
        },
      };
    }
    return {
      url: proxy + '?' + qs,
      useDirect: false,
      fetchInit: {
        method: 'GET',
        credentials: 'same-origin',
      },
    };
  }

  if (!w.__AOGEN_API_BASE__) w.__AOGEN_API_BASE__ = DEFAULT_BASE;

  w.AogenApi = w.AogenApi || {
    base: resolveBase,
    url: apiUrl,
    shopDomain: shopDomain,
    useDirectEventsCatalog: useDirectEventsCatalog,
    buildEventsRequest: buildEventsRequest,
    eventsCatalogUrl: function (proxyBase, eventsPath) {
      return joinProxyPath(proxyBase, eventsPath);
    },
    joinProxyPath: joinProxyPath,
    waitlistUrl: function () {
      var custom = String(w.__WB_WAITLIST_API_URL__ || '').trim();
      return custom || apiUrl('/api/public/waitlist');
    },
    liveStateUrl: function () {
      return apiUrl('/api/public/workshop-venue/event-live-state');
    },
    validateUrl: function () {
      return apiUrl('/api/public/workshop-venue/capacity/validate');
    },
    configUrl: function () {
      return apiUrl('/api/public/workshop-booking/config');
    },
    fetchEventsCatalog: function (queryString, proxyBase, eventsPath, fetchOpts) {
      var built = buildEventsRequest(queryString, proxyBase, eventsPath);
      var opts = Object.assign({}, built.fetchInit || {}, fetchOpts || {});
      var qs = String(queryString || '');
      return fetch(built.url, opts).then(function (res) {
        if (!built.useDirect && res.status === 404) {
          var primaryBase = String(proxyBase || DEFAULT_PROXY_BASE).replace(/\/+$/, '');
          var fallbackBase = '/apps/workshop-event';
          if (primaryBase === fallbackBase) return res;
          return fetch(joinProxyPath(fallbackBase, eventsPath || DEFAULT_EVENTS_PATH) + '?' + qs, opts);
        }
        return res;
      });
    },
  };
})(typeof window !== 'undefined' ? window : this);
